// @flow
import React from 'react';

import type { Member } from '../../models/group_chats/Member.js';

type Props = {
  member: Member,
  selectable?: boolean,
  selected?: boolean,
  onClick?: (member: Member) => void,
};

export default function MemberItem(props: Props) {
  const { member, selectable, selected, onClick } = props;
  const selectedClass = selectable && selected ? 'member--selected' : '';
  return (
    <div
      className={`ml-0 pt-15 pb-15 member ${selectedClass}`}
      onClick={onClick}
    >
      <div className="member__icon">
        <img src={member.avatar} />
      </div>
      <div className="member__info ml-10">
        <span className="member__info--detail">{member.name}</span>
        {member.office != null && (
          <span className="member__info--detail">{member.office}</span>
        )}
      </div>
      {selectable && (
        <div className="member__status">
          {selected ? '指名解除' : '指名する'}
        </div>
      )}
    </div>
  );
}
